export default {"src":"/_next/static/media/icon-discord-invert.006db3f5.svg","height":31,"width":40,"blurWidth":0,"blurHeight":0};